<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <v-row no-gutters>
          <v-col cols="12">
            <div class="rowinfo">
              <v-text-field
                v-model="computedValue"
                outlined
                dense
                clearable
                label="تعداد اسکن/کلیک"
                placeholder="حداکثر تعداد اسکن کیوآر"
                append-icon="mdi-numeric"
                clear-icon="mdi-close-circle-outline"
                type="number"
                max="100000"
                hint="از 0 تا 100,000"
                class="rowinfo"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-click-computedValue`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="تعداد اسکن/کلیک"
              />
            </div>
          </v-col>
        </v-row>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
export default {
  name: "manageClickLimitQr",

  props: {
    value: [String, Number],
    data: Object,
  },
  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "manager-click-limitQr",
    };
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style scoped></style>
